(() => {
  // app/scripts/filter-component.js
  var showMoreCount = 7;
  var { debounceTime, addEvent } = theme;
  customElements.define(
    "filter-component",
    class extends HTMLElement {
      constructor() {
        super();
        this.containerFilterActive = this.querySelectorAll(".filter-active");
        this.filterActiveList = this.querySelectorAll(".filter-active ul");
        this.container = this.closest("[data-section-id]");
        this.cache = [];
        this.andLogic = JSON.parse(this.dataset.andLogic || "false");
        this.filterType = this.dataset.type || "attribute";
        this.form = this.querySelector("form");
        this.inputClass = `input[form="${this.form.id}"]`;
        this.viewStyle = this.querySelector("view-style");
        this.popupSelectStore = document.querySelector("popup-select-store");
        this.pickUp();
        let storage = sessionStorage.getItem("collection_cookie");
        let infinite_loading = document.querySelector("infinite-loading");
        if (storage != null && infinite_loading == null) {
          this.check = true;
          storage = JSON.parse(storage);
          document.querySelectorAll(".list-products  product-card").forEach((e) => {
            if (e.dataset.productId == storage.id) {
              e.classList.add("active");
              this.scroll(e);
              sessionStorage.removeItem("collection_cookie");
              this.check = false;
            }
          });
        }
      }
      connectedCallback() {
        this.addEvents();
        this.checkFilterActive();
        this.addEventListener("change:store", (evt) => {
          this.pickUp();
          let query = this.getQueryString;
          if (query.includes("filter.v.availability=1")) {
            this.submit();
          }
        });
      }
      scroll(scrollToEl) {
        const topOfElement = window.scrollY + scrollToEl.getBoundingClientRect().top - document.querySelector(".header-section").offsetHeight;
        window.scroll({ top: topOfElement, behavior: "smooth" });
      }
      pickUp() {
        let customChangeStore = this.querySelector("custom-change-store");
        if (!customChangeStore)
          return;
        let store = this.popupSelectStore.getStore();
        let jsMyStore = customChangeStore.querySelector(".jsMyStore");
        let btnChange = customChangeStore.querySelector(".btn-change");
        let btnSelect = customChangeStore.querySelector(".btn-select");
        console.log("store :>> ", store);
        if (store) {
          jsMyStore.innerHTML = store.storeName;
          btnChange.classList.toggle("none", false);
          btnSelect.classList.toggle("none", true);
        } else {
          jsMyStore.innerHTML = "";
          btnSelect.classList.toggle("none", false);
          btnChange.classList.toggle("none", true);
        }
      }
      appendStore(query) {
        let stringQuery = query;
        const customChangeStore = this.querySelector("custom-change-store");
        if (!customChangeStore)
          return;
        const jsMyStore = customChangeStore.querySelector(".jsMyStore");
        let storeName = jsMyStore.textContent.trim() || "";
        if (storeName && storeName.includes("(Head Office)")) {
          storeName = storeName.replace("(Head Office)", "").trim();
        }
        let temp = "filter.v.availability=1&" + jsMyStore.dataset.filterName + storeName;
        stringQuery = stringQuery.replace("filter.v.availability=1", temp);
        return stringQuery;
      }
      checkFilterActive() {
        let filterActive = this.querySelectorAll(
          ".sidebar-section .filter-active-list li"
        );
        let btnFilter = this.querySelector(".filter-btn");
        if (filterActive?.length) {
          btnFilter.classList.add("has-filter");
        }
      }
      addEvents() {
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        this.addEventListener("change", ({ target: selectedTarget }) => {
          if (selectedTarget.name == "sortBy") {
            const sortEl = [...this.querySelectorAll("[name=sort_by]")].find(
              (item) => item.value == selectedTarget.value
            );
            sortEl.checked = true;
            selectedTarget = sortEl;
          }
          this.onChange(selectedTarget);
        });
        this.form.addEventListener("submit", (e) => {
          e.preventDefault();
          this.submit();
        });
        this.viewStyle.querySelectorAll("div")?.forEach(
          (item) => item.addEventListener("click", (e) => {
            this.viewStyle.classList = "";
            this.viewStyle.classList.add(item.classList[0]);
            this.classList.remove(item.dataset.classRemove);
            this.classList.add(item.classList[0]);
          })
        );
        this.removeFilter();
        this.filterSearch();
        this.addEventListener("click", (evt) => {
          const { target } = evt;
          if (target.closest(".jsFilterReset")) {
            evt.preventDefault();
            this.uncheckInput();
            this.submit();
          }
        });
      }
      onChange(target) {
        const input = target;
        !this.andLogic && this.uncheckInput(input);
        if (target.hasAttribute("auto-submit"))
          this.submit();
      }
      uncheckInput(input = null) {
        let inputList;
        if (input) {
          inputList = this.querySelectorAll(
            `input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`
          );
        } else {
          inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
        }
        inputList.forEach((i) => {
          i.removeAttribute("checked");
          i.checked = false;
        });
      }
      get getQueryString() {
        const formData = new FormData(this.form);
        const query = new URLSearchParams(formData);
        if (this.filterType == "attribute")
          return query.toString();
        const arrayFilter = [];
        let sort = "";
        query.split("&").map((i) => {
          !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
        });
        return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
      }
      submit() {
        this.classList.add("is-loading");
        let query = this.getQueryString;
        if (query.includes("filter.v.availability=1")) {
          query = this.appendStore(query);
        }
        let url = this.form.action;
        url += this.filterType == "attribute" ? url.includes("?") ? "&" : "?" : "/";
        url += query;
        url += this.filterType == "attribute" || query.includes("?") ? "&" : "?";
        url += `section_id=${this.dataset.sectionId}`;
        fetch(url).then((e) => e.text()).then((html) => {
          const div = document.createElement("div");
          div.innerHTML = html;
          this.render(div, query);
          this.updatePriceRange();
          this.checkFilterActive();
          this.pickUp();
          this.classList.remove("is-loading");
        });
      }
      updatePriceRange() {
        if (this.querySelectorAll("price-range .noUi-base").length < 2)
          return;
        const noUi = this.querySelector("price-range .noUi-base");
        if (noUi) {
          noUi.remove();
        }
      }
      render(result, searchParams = null) {
        if (searchParams) {
          let splitCharacter;
          if (this.filterType == "attribute") {
            splitCharacter = this.form.action.includes("?") ? "&" : "?";
          } else {
            splitCharacter = !searchParams.includes("?") || searchParams.includes("?") && searchParams.split("?")[0].length ? "/" : "";
          }
          history.pushState(
            { searchParams },
            "",
            `${this.form.action}${searchParams && splitCharacter.concat(searchParams)}`
          );
        }
        this.querySelector("#" + this.dataset.product).innerHTML = result.querySelector("#" + this.dataset.product).innerHTML;
        this.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
          const newItem = result.querySelector(`[class="${item.className}"]`);
          if (newItem) {
            item.innerHTML = newItem.innerHTML;
          }
        });
        this.removeFilter();
      }
      removeFilter() {
        this.querySelectorAll(".jsFilterRemove")?.forEach((item) => {
          item.addEventListener("click", (event) => {
            event.preventDefault();
            const { value } = item.querySelector(".jsValue").dataset;
            this.querySelectorAll(`input[form="${this.form.id}"]`).forEach(
              (item2) => {
                if (item2.value != value)
                  return;
                item2.checked = false;
              }
            );
            this.submit();
          });
        });
      }
      filterSearch() {
        this.querySelectorAll(".jsFilterSearch")?.forEach((item) => {
          const parentEl = item.closest(".filter-block");
          item.addEventListener("click", () => {
            const value = item.previousElementSibling.value;
            searchFilterValue(parentEl, value);
          });
          item.previousElementSibling.addEventListener("keyup", (e) => {
            (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);
            const value = item.previousElementSibling.value;
            searchFilterValue(parentEl, value);
          });
        });
        const clearField = (el) => {
          el.querySelectorAll("li.matched")?.forEach(
            (item) => item.classList.remove("matched")
          );
        };
        const searchFilterValue = (container, value) => {
          const filterListItem = container.querySelectorAll("[name*=filter]");
          if (value.length) {
            container.classList.add("searching");
            filterListItem.forEach((item) => {
              let regex = new RegExp(value, "i");
              const parentEl = item.closest("li");
              parentEl.classList.toggle("matched", item.value.match(regex));
            });
          } else {
            container.classList.remove("searching");
            container.querySelectorAll(".matched")?.forEach((item) => item.classList.remove("matched"));
          }
          container.querySelector(".jsFilterShowMore")?.classList.toggle("none", value.length);
        };
      }
    }
  );
  addEvent("click", ".jsFilterShowMore", ({ target }) => {
    const container = target.closest(".filter-block");
    if (target.getAttribute("data-more") == "true") {
      const filterList = container.querySelectorAll(".jsFilterToggle.none");
      filterList.forEach((item, value) => {
        value < showMoreCount && item.classList.remove("none");
      });
      const hiddenFilterCount = container.querySelectorAll(
        ".jsFilterToggle.none"
      ).length;
      target.setAttribute("data-more", !!hiddenFilterCount);
    } else {
      const totalFilterItems = container.querySelectorAll(".jsFilterToggle");
      const filterList = container.querySelectorAll(".jsFilterToggle:not(.none)");
      [...filterList].forEach((item, value) => {
        value >= showMoreCount && item.classList.add("none");
      });
      target.setAttribute("data-more", "true");
    }
  });
})();
